import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import LandingPage from "../pages/LandingPage";
import DynamicLinkGenerator from "../pages/DynamicLinkGenerator";
import BlogPage from "../pages/BlogPage";
import BlogPostReader from "../components/Blog/BlogPostReader";
import ContactUsPage from "../pages/ContactUsPage";
import ContactSalesPage from "../pages/ContactSalesPage";
import PricingPage from "../pages/PricingPage";
import PrivacyPolictyPage from "../pages/PrivacyPolictyPage";
import TermsPage from "../pages/TermsPage";
import SecurityPage from "../pages/SecurityPage";
import SLAPage from "../pages/SLAPage";
import CrossAppMessaging from "../pages/CrossAppMessaging";
import Engagement from "../pages/Engagement";
import Measure from "../pages/Measure";
import Analyse from "../pages/Analyse";
import ProductPage from "../pages/ProductPage";
import DataAnalyticsPage from "../pages/DataAnalyticsPage";
import MarketingPage from "../pages/MarketingPage";
import IncreaseEngagement from "../pages/IncreaseEngagement";
import AppGrowthPage from "../pages/AppGrowthPage";
import PlatformMobilePage from "../pages/PlatformMobilePage";
import PlatformWebPage from "../pages/PlatformWebPage";
import UsecasePage from "../pages/UsecasePage";
import Firebase from "../pages/Firebase";

export const router = createBrowserRouter([
  {
    element: <App />,
    children: [
      {
        path: "/",
        element: <LandingPage />,
      },
      {
        path: "messaging",
        element: <CrossAppMessaging />,
      },
      {
        path: "engagement",
        element: <Engagement />,
      },
      {
        path: "measure",
        element: <Measure />,
      },
      {
        path: "analyse",
        element: <Analyse />,
      },
      {
        path: "product",
        element: <ProductPage />,
      },
      {
        path: "data-analytics",
        element: <DataAnalyticsPage />,
      },
      {
        path: "marketing",
        element: <MarketingPage />,
      },
      {
        path: "increase-engagement",
        element: <IncreaseEngagement />,
      },
      {
        path: "app-growth",
        element: <AppGrowthPage />,
      },
      {
        path: "platform-mobile",
        element: <PlatformMobilePage />,
      },
      {
        path: "platform-web",
        element: <PlatformWebPage />,
      },
      {
        path: "usecase",
        element: <UsecasePage />,
      },
      {
        path: "security",
        element: <SecurityPage />,
      },
      {
        path: "sla",
        element: <SLAPage />,
      },
      {
        path: "create",
        element: <DynamicLinkGenerator />,
      },
      {
        path: "contact",
        element: <ContactUsPage />,
      },
      {
        path: "sales",
        element: <ContactSalesPage />,
      },
      {
        path: "pricing",
        element: <PricingPage />,
      },
      {
        path: "privacy",
        element: <PrivacyPolictyPage />,
      },
      {
        path: "terms",
        element: <TermsPage />,
      },
      {
        path: "blog",
        element: <BlogPage />,
      },
      {
        path: "/blog/:id",
        element: <BlogPostReader />,
      },
      {
        path: "/migrate-from-fireabse-dynamic-links",
        element: <Firebase />,
      },
      {
        path: "prerendered/*",
        element: null, // Or just an empty component that renders nothing
      },
      {
        path: "*",
        element: <LandingPage />,
      },
    ],
  },
]);
